import React from "react";
import AdminCustomersTable from "../components/tables/AdminCustomersTable";

export default function CustomersListPage() {
  return <AdminCustomersTable />;
}
